export default "__VITE_ASSET__9ffaf118__"